import { render, staticRenderFns } from "./StatementManipulate.vue?vue&type=template&id=e4b468ec&scoped=true"
import script from "./StatementManipulate.vue?vue&type=script&lang=js"
export * from "./StatementManipulate.vue?vue&type=script&lang=js"
import style0 from "./StatementManipulate.vue?vue&type=style&index=0&id=e4b468ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b468ec",
  null
  
)

export default component.exports